import { useEffect } from 'react';
import { isBrowser } from 'utils/misc-utils';
import { attachSegmentAnalyticsProxy } from './attach-segment-analytics-proxy';

export const useSegmentClientTag = (segmentId?: string | null): void => {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!segmentId || !isBrowser() || !window) {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return () => {};
    }

    try {
      attachSegmentAnalyticsProxy(window, segmentId);
    } catch (e) {
      // eslint-disable-next-line i18next/no-literal-string
      console.error('Error when attempting to init segment', e);
    }

    return () => {
      window.analytics = undefined;
    };
  }, [segmentId]);
};
